import React from 'react';
import { CONSTANTS } from '../../data';
import { ASSETS } from '../../assetManifest';
import { CollapsiblePanel } from '../ui/CollapsiblePanel';
import type { AssetsSchema } from '../../assetManifestTypes';

interface WorkspacePanelProps {
  fusedElements: string[];
  setFusedElements: React.Dispatch<React.SetStateAction<string[]>>;
  isMobile: boolean;
  collapsedPanels: Set<string>;
  onTogglePanel: (panelId: string) => void;
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  onCircleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
}

export const WorkspacePanel: React.FC<WorkspacePanelProps> = ({
  fusedElements,
  setFusedElements,
  isMobile,
  collapsedPanels,
  onTogglePanel,
  onDragOver,
  onCircleDrop
}) => {
  const typedAssets = ASSETS as AssetsSchema;

  return (
    <div className={`workspace-panel ${isMobile ? 'mobile-panel' : 'desktop-panel'}`}>
      <CollapsiblePanel 
        id="fusion-workspace" 
        title={CONSTANTS.PANEL_TITLES.workspace}
        isCollapsed={collapsedPanels.has('fusion-workspace')}
        onToggle={onTogglePanel}
      >
        <div className="workspace-content">
          <p className="workspace-instructions">
            {isMobile ? 'Tap elements to select, then tap Fuse' : 'Drag two elements into the circle to fuse them.'}
          </p>
          <div
            id="fusion-circle"
            className={`fusion-circle ${isMobile ? 'mobile-fusion-circle' : ''}`}
            onDragOver={onDragOver}
            onDrop={onCircleDrop}
          >
            {fusedElements.length === 0 && (
              <p className="fusion-placeholder">
                {isMobile ? 'Selected elements appear here' : 'Drop elements here'}
              </p>
            )}
            {fusedElements.map((element) => {
              const iconKey = element === 'emotion' ? 'emotion_wave_heart' : element;
              const iconAsset = typedAssets.icons[iconKey];
              return (
                iconAsset && (
                  <div key={element} className="fused-element" data-fused-element={element}>
                    <img
                      src={iconAsset.path}
                      alt={element}
                      className="w-full h-full object-contain pointer-events-none"
                    />
                  </div>
                )
              );
            })}
          </div>
          {isMobile && fusedElements.length === 2 && (
            <button
              className="mobile-fuse-btn"
              onClick={() => {
                const event = new DragEvent('drop');
                Object.defineProperty(event, 'dataTransfer', {
                  value: {
                    getData: () => fusedElements[1]
                  }
                });
                onCircleDrop(event as any);
              }}
            >
              Fuse Elements
            </button>
          )}
        </div>
      </CollapsiblePanel>
    </div>
  );
};
